import { fetcher } from "helpers/fetcher";

import { TAddAssigmentMemberReq, TAddAssigmentMemberRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const addAssigmentMember = async (payload: TAddAssigmentMemberReq) => {
  return await fetcher<TAddAssigmentMemberRes, TAddAssigmentMemberReq["data"]>(
    ENDPOINT.BU.ADD_ASSIGNMENT_MEMBER,
    {
      data: payload.data,
      headers: {
        [API_HEADER.BU_ID]: payload.buId,
      },
    }
  );
};

export const mutationAddAssigmentMember = async (
  payload: TAddAssigmentMemberReq
) => {
  return (await addAssigmentMember(payload)).data;
};

mutationAddAssigmentMember._key = (payload: TAddAssigmentMemberReq) => [
  ENDPOINT.BU.ADD_ASSIGNMENT_MEMBER.url,
  payload,
];
